import { useState, useEffect } from "react"
import { syncFaviconWithTheme } from "@/lib/ui/favicon"

const DARK_MODE_KEY = "hps-dark-mode"

export function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === "undefined") return false
    const stored = localStorage.getItem(DARK_MODE_KEY)
    if (stored !== null) return stored === "true"
    return window.matchMedia("(prefers-color-scheme: dark)").matches
  })

  useEffect(() => {
    const root = document.documentElement
    if (isDark) {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }
    localStorage.setItem(DARK_MODE_KEY, String(isDark))
    syncFaviconWithTheme()
  }, [isDark])

  const toggle = () => setIsDark((prev) => !prev)

  return { isDark, toggle, setIsDark }
}
